import i18n from '@/phoenix/translations'

// define a global variable so that the vite I18n functions are available in legacy asset pipeline js that is evaled outside of the
// vite context.

// This should be retired after we finish retiring asset pipeline JS.
if (window.I18n === undefined) {
  window.I18n = i18n
}
